import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '@enviroments/environment';
import { Member } from '@models/myoffice/member/member.model';
import { AbPosInfo } from '@app/models/myoffice/member/abpos-info.model';

@Injectable({
  providedIn: 'root'
})
export class MemberSearchService {

  constructor(private _http: HttpClient) { }

  searchMember(params: any) {
    let url = '';
    if(params.screen == 'SearchMem'){
      url = `${environment.apiUrl}/member/search/popupMediusKR`;
    }else{
      url = `${environment.apiUrl}/member/search`;
    }
   
    return this._http.post<Member[]>(url, params);
  }
  countMember(params: any) {
    let url = '';
    if(params.screen == 'SearchMem'){
      url = `${environment.apiUrl}/member/count/popupMediusKR`;
    }else{
      url = `${environment.apiUrl}/member/count`;
    }
    return this._http.post<Number>(url, params);
  }

  loadABPosInfo(userid: string) {
    let url = `${environment.apiUrl}/member/abPos-info?comid=${environment.comId}&userid=${userid}`;
    return this._http.get<AbPosInfo>(url);
  }

  searchMemberPop(params: any) {
    let url =''; 
    const currentPath = window.location.pathname;
    if(currentPath == '/my-office/member-management/holding-tank'){
      url = `${environment.apiUrl}/member/search/popupHoldingTankMediusKR`;
    }else{
      url = `${environment.apiUrl}/member/search/popupMediusKR`;
    }
    
    return this._http.post<Member[]>(url, params);
  }
  countMemberPop(params: any) {
    let url =''; 
    const currentPath = window.location.pathname;
    if(currentPath == '/my-office/member-management/holding-tank'){
      url = `${environment.apiUrl}/member/count/popupHoldingTankMediusKR`;
    }else{
      url = `${environment.apiUrl}/member/count/popupMediusKR`;
    }
    
    return this._http.post<Number>(url, params);
  }
}

